import { rtkApi, GET_STUDENT_INVOICES_BALANCE } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import type { IStudentInvoicesBalance } from './types';

/**
 * Полные финансы студенту не показываем — они в админке. В кабинете остались только
 * три цифры в карточке профиля, поэтому из всех ручек счетов нужна одна: сводка.
 *
 * `/student/invoices`, `/student/invoices/transactions` и `/student/invoices/statement`
 * на сервере живы, но вызывать их отсюда больше неоткуда.
 */
const invoicesApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    // GET /student/invoices/balance
    getStudentInvoicesBalance: build.query<IStudentInvoicesBalance, void>({
      query: () => '/student/invoices/balance',
      transformResponse: (response: SuccessApiResponse<IStudentInvoicesBalance>) => response.data,
      providesTags: [GET_STUDENT_INVOICES_BALANCE],
    }),
  }),
});

export const { useGetStudentInvoicesBalanceQuery } = invoicesApi;
